export default "__VITE_ASSET__cE9cz1lA__"